import axios from "axios";
import { STATUSES } from "./apiStatus";
import { base_url } from "../utils";
import { getAccesstoken } from "../helpers/utils";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const CACHE_TTL = 2 * 60 * 1000;
const CACHE_KEY = "digilocker_profile_v2";

const readCache = () => {
  try {
    const cached = JSON.parse(sessionStorage.getItem(CACHE_KEY));
    if (cached?.data && Date.now() - cached.savedAt < CACHE_TTL) {
      return cached.data;
    }
    sessionStorage.removeItem(CACHE_KEY);
  } catch {
    sessionStorage.removeItem(CACHE_KEY);
  }
  return null;
};

const writeCache = (data) => {
  try {
    sessionStorage.setItem(
      CACHE_KEY,
      JSON.stringify({ savedAt: Date.now(), data })
    );
  } catch {
    // Requests continue normally when browser storage is unavailable.
  }
};

export const invalidateProfileCache = () => {
  try {
    sessionStorage.removeItem(CACHE_KEY);
  } catch {
    // No action is required when browser storage is unavailable.
  }
};

export const companyProfile = createAsyncThunk(
  "profile/fetch",
  async (request, { rejectWithValue }) => {
    const forceRefresh =
      request && typeof request === "object" && request.forceRefresh;

    try {
      if (!forceRefresh) {
        const cached = readCache();
        if (cached) return cached;
      }

      const token = getAccesstoken();
      const response = await axios.get(
        `${base_url}/digilocker/getUserDetails`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      writeCache(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const profileSlice = createSlice({
  name: "profile",
  initialState: {
    profileData: {},
    status: STATUSES.IDLE,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(companyProfile.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(companyProfile.fulfilled, (state, action) => {
        state.profileData = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(companyProfile.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
        state.error = action.payload;
      });
  },
});

export default profileSlice.reducer;
